import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=3d4383c2&scoped=true&"
import script from "./EditOrganization.vue?vue&type=script&lang=js&"
export * from "./EditOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4383c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4383c2')) {
      api.createRecord('3d4383c2', component.options)
    } else {
      api.reload('3d4383c2', component.options)
    }
    module.hot.accept("./EditOrganization.vue?vue&type=template&id=3d4383c2&scoped=true&", function () {
      api.rerender('3d4383c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/OrganizationsPage/EditOrganization.vue"
export default component.exports